import { StaffId, OfficeId, TaskTypeId, RoleId } from "./ids";

export default class Staff {
  id: StaffId = 0;
  officeId: OfficeId = 0;
  workTypeIds: TaskTypeId[] = [];
  name: string = "";
  tel: string = "";
  email: string = "";
  roleId: RoleId = 0;
  isHiddenInfo: number = 0;
  isInternal: boolean = false;
  userId: number = 0;
  hasTaskSub: boolean = false;
  scheduleNotification!: boolean;
  canModifyAssignedTasks!: boolean;
  canViewAllUninvitedProjects!: boolean;

  public constructor(params: Partial<Staff> = {}) {
    if (params.id) this.id = params.id;
    if (params.officeId) this.officeId = params.officeId;
    if (params.workTypeIds) this.workTypeIds = params.workTypeIds;
    if (params.name) this.name = params.name;
    if (params.tel) this.tel = params.tel;
    if (params.email) this.email = params.email;
    if (params.roleId) this.roleId = params.roleId;
    if (params.isHiddenInfo) this.isHiddenInfo = params.isHiddenInfo;
    if (params.isInternal) this.isInternal = params.isInternal;
    if (params.userId) this.userId = params.userId;
    if (params.hasTaskSub) this.hasTaskSub = params.hasTaskSub;
    if (params.scheduleNotification)
      this.scheduleNotification = params.scheduleNotification;
    this.canModifyAssignedTasks = params.canModifyAssignedTasks as boolean;
    this.canViewAllUninvitedProjects = params.canViewAllUninvitedProjects as boolean;
  }
}
